import React, { useState, useEffect } from 'react';

export const ListProducts = (props) => {
    const [products, setProducts] = useState([]);
    const [endpoint, setEndpoint] = useState('');

    useEffect(() => {
        fetch('https://webapi.dgapi.me/getProducts?tenant=TLEMURIA')
            .then(res => res.json())
            .then(data => {
                if (data.packages) {
                    console.log(data.packages);
                    setProducts(data.packages);
                    setEndpoint("https://pay.dpay.zone/pay/");
                    //setEndpoint(data.endpoint);
                }
            })
            .catch(err => console.error('Error fetching products:', err));
    }, []);

    const generateUrl = (id_package) => {
        let jwt = localStorage.getItem('jwtToken');
        if (!endpoint) return;
        let baseUrl = `${endpoint}${id_package}/${jwt}?redeemPin=true`;
        console.log(baseUrl);
        return baseUrl;
    };

    return (
        <div className="container">
            <div className="row">
                {products.map((product) => (
                    <div key={product.id} className="col-4 mb-4">
                        <div className="card p-3 payCard">
                            <h5>{product.name}</h5>
                            <p>{product.price}</p>
                            <p>{product.lemurians} Lemurians</p>
                            <button className="generic-button" onClick={() => {
                                const url = generateUrl(product.id);
                                if (url) window.open(url, '_blank');
                            }}>Purchase</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
